export default __webpack_public_path__ + "static/agency-rate-a5b2daa91d150fca64a9069a382af70a.png";